import APIConstants from 'spa/constants/APIConstants';

export function apiError(message) {
  return {
    type: APIConstants.API_ERROR,
    message,
  };
}
